import { z } from "zod";

import { authSchema } from "../../../auth";

export const coppaSchema = authSchema.extend({
  promo: z.string().nullable().optional(),
});

export type CoppaSchema = z.infer<typeof coppaSchema>;
